/* @flow */
import { Container } from 'flux/utils';
import React from 'react';
import RSVPDialog from 'payments/components/RSVPDialog.jsx';
import ActivityStore from 'payments/stores/ActivityStore';
import Activity from 'entities/Activity';
import type {Attendance} from 'entities/ActivityRecipient'; // eslint-disable-line
import * as actions from 'payments/reducers/activityRecipients';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ActivityRecipient from 'entities/ActivityRecipient'; // eslint-disable-line
import CurrentUser from 'auth/CurrentUser';
import ActivityActions from 'payments/actions/ActivityActions';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

type Props = {
  activityId: string,
  initialRSVP?: ?Attendance,
  onRequestHide?: () => void,
  activityRecipient?: ?ActivityRecipient,
  updateLocalActivityRecipient: (activityId: string, activityRecipient: ActivityRecipient) => void,
};

type State = {
  activity: Activity,
  isUnderage: boolean,
};

class RSVPDialogContainer extends React.Component {
  props: Props;
  state: State;

  static getStores() {
    return [
      ActivityStore,
      CurrentUser,
    ];
  }

  static calculateState(prevState, props) {
    return {
      activity: ActivityStore.getActivityById(props.activityId),
      isUnderage: !!(CurrentUser.isSignedIn() && CurrentUser.getUser().isUnderage()),
    };
  }

  componentWillMount() {
    if (!this.state.activity) {
      ActivityActions.loadByUuid(this.props.activityId);
    }
  }

  render() {
    if (!this.state.activity) {
      return <CenteredLoadingIndicator />;
    }

    return (
      <RSVPDialog
        isUnderage={this.state.isUnderage}
        activity={this.state.activity}
        initialRSVP={this.props.initialRSVP}
        onRequestHide={this.props.onRequestHide}
        activityRecipient={this.props.activityRecipient}
        updateLocalActivityRecipient={this.props.updateLocalActivityRecipient}
      />
    );
  }
}

function mapStateToProps(state: Object, props: Object) {
  const activity = state.activityRecipients.activities[props.activityId] || {};

  return {
    activityRecipient: activity.currentUserRecipient,
  };
}

const mapDispatchToProps = (dispatch: Function) =>
  bindActionCreators({
    updateLocalActivityRecipient: actions.updateLocalCurrentUserActivityResponse,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(
  Container.create(RSVPDialogContainer, { withProps: true })
);



// WEBPACK FOOTER //
// ./src/payments/containers/RSVPDialogContainer.jsx